import { getAuth } from 'firebase/auth';
import { getFirebaseProjectId } from '../utils/firebaseProject';

const getCloudFunctionsBaseUrl = () => {
  const useEmulators =
    (process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true' ||
      process.env.REACT_APP_ENVIRONMENT === 'emulator') &&
    process.env.NODE_ENV !== 'production';

  if (useEmulators) {
    const port = process.env.REACT_APP_FUNCTIONS_PORT || '5002';
    const projectId = getFirebaseProjectId();
    return `http://127.0.0.1:${port}/${projectId}/asia-south1`;
  }
  return process.env.REACT_APP_FIREBASE_FUNCTIONS_URL || `https://asia-south1-${getFirebaseProjectId()}.cloudfunctions.net`;
};

const callCloudFunction = async (functionName, data) => {
  const auth = getAuth();
  const user = auth.currentUser;
  let token = null;

  if (user) {
    try {
      token = await user.getIdToken();
    } catch (error) {
      console.error('Error getting ID token:', error);
      throw new Error('Failed to authenticate for cloud function');
    }
  }

  const baseUrl = getCloudFunctionsBaseUrl();
  const url = `${baseUrl}/${functionName}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
      },
      body: JSON.stringify(data),
    }).catch(fetchError => {
      // Silently catch CORS/network errors - fallback will handle it
      throw new Error('CORS_ERROR');
    });

    if (!response.ok) {
      const errorBody = await response.text();
      // Only log non-404/500 errors
      if (response.status !== 404 && response.status !== 500) {
      console.error(`Cloud function ${functionName} failed with status ${response.status}:`, errorBody);
      }
      throw new Error(`Cloud function ${functionName} failed: ${errorBody}`);
    }

    return await response.json();
  } catch (error) {
    // Silently handle CORS errors - fallback will be used
    if (error.message === 'CORS_ERROR' || error.message.includes('Failed to fetch')) {
      throw new Error('CORS_ERROR');
    }
    // Only log unexpected errors
    if (!error.message.includes('CORS')) {
    console.error(`Error calling cloud function ${functionName}:`, error);
    }
    throw error;
  }
};

const cloudFunctionsService = {
  callCloudFunction,
};

export default cloudFunctionsService;
